<template>
  <div class="popular-direction-wrapper">
    <vz-skeleton 
      v-for="i in count" 
      :key="i"
      type="rounded" 
      height="50"
      class="mb-10" 
    />
  </div>
</template>

<script setup lang="ts">
import VzSkeleton from '~/components/ui-kit/vz-skeleton.vue'

const props = defineProps({
  isDispatch: {
    type: Boolean,
    default: false
  }
})

const count = computed(() => {
  return props.isDispatch ? 8 : 10
})
</script>
